/**
 * resolve factor to plain value
 * @param theme required for designGrid.base
 * @param factor
 */
export default function resolveFactor(theme, factor) {
    if (factor === undefined || factor === false) {
        return undefined;
    }
    if (typeof factor === 'string') {
        return factor;
    }
    if (typeof factor === 'object') {
        return factor.custom;
    }
    // convert to number in case of true
    var factorValue = factor;
    return theme.designGrid.base * factorValue;
}
//# sourceMappingURL=FactorResolver.js.map